import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Accordion } from 'components/core/Accordion';
import './FAQItem.scss';

export function FAQItem({ className, content, type, iconType, openItemIndex, onToggleItem }) {
	return (
		<div className={classnames(className)}>
			<Accordion
				className={className}
				content={content}
				type={type}
				iconType={iconType}
				openItemIndex={openItemIndex}
				onToggleItem={onToggleItem}
			/>
		</div>
	);
}

FAQItem.propTypes = {
	className: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.object),
	type: PropTypes.string,
	iconType: PropTypes.string,
	openItemIndex: PropTypes.number,
	onToggleItem: PropTypes.func,
};

export default FAQItem;
